/**
 * Yes, the implementation of this is not ideal, to say the least.
 * It simply mirrors the backend code to perform the same validation,
 * and will need to be updated if we decide to switch to a better implementation
 */
export function validateNoPartOfUsername(username: string, password: string): boolean {
  return username && password && !username.startsWith(password) && !username.endsWith(password);
}
